import { type EventReminder, duplicateEventStartTime } from 'models';
import { useMemo } from 'react';
import { getDatePickerDateType } from 'ui';
import { useFormatTime, useGenerateDefaultReminderHeroImage } from '../../../hooks';
import type { DuplicateReminderFormValues } from '../DuplicateReminderForm';

export const useGetInitialValues = (event: EventReminder) => {
  const formatTime = useFormatTime();
  const defaultHeroImage = useGenerateDefaultReminderHeroImage();

  return useMemo((): Partial<DuplicateReminderFormValues> => {
    const { allDay: isAllDay, html, name, startTime, text } = event;
    const duplicateStartDate = duplicateEventStartTime(startTime);

    return {
      duplicateInviteesFromEvent: true,
      heroImage: defaultHeroImage,
      htmlDescription: html,
      isAllDay: isAllDay ?? false,
      name,
      startDate: getDatePickerDateType(duplicateStartDate),
      startTime: formatTime(duplicateStartDate),
      textDescription: text,
    };
  }, [defaultHeroImage, event, formatTime]);
};
